const copy = {
    ru: {
        label: 'Движение денег', ALL: 'Все', INCOME: 'Приходы', EXPENSE: 'Расходы',
        help: 'Направление определяется изменением денег на счёте; учитываются также переводы, возвраты, начальные остатки и корректировки.',
        allAccounts: 'Перевод между доступными счетами может быть в обоих направлениях; в строке показан соответствующий счёт.',
        emptyIncome: 'За выбранный период приходов по этим фильтрам нет.',
        emptyExpense: 'За выбранный период расходов по этим фильтрам нет.',
    },
    az: {
        label: 'Pul hərəkəti', ALL: 'Hamısı', INCOME: 'Mədaxil', EXPENSE: 'Məxaric',
        help: 'İstiqamət hesabdakı pulun artmasına və ya azalmasına görə müəyyən olunur. Köçürmələr, qaytarmalar, ilkin qalıqlar və düzəlişlər də daxildir.',
        allAccounts: 'Əlçatan hesablar arasındakı köçürmə hər iki istiqamətdə görünə bilər; sətirdə uyğun hesab göstərilir.',
        emptyIncome: 'Seçilmiş dövrdə bu filtrlərə uyğun mədaxil yoxdur.',
        emptyExpense: 'Seçilmiş dövrdə bu filtrlərə uyğun məxaric yoxdur.',
    },
    en: {
        label: 'Money movement', ALL: 'All', INCOME: 'Money in', EXPENSE: 'Money out',
        help: 'Direction follows the change in money on the account, including transfers, returns, opening balances and corrections.',
        allAccounts: 'A transfer between accessible accounts can appear in both directions; the matching account is shown.',
        emptyIncome: 'No money in matches these filters for the selected period.',
        emptyExpense: 'No money out matches these filters for the selected period.',
    },
};
export const cashJournalText = (locale) => copy[locale];
/** Presentation of the server-selected effect. Group before testing signs, including corrections. */
export function cashJournalEffect(row, readableIds, selectedAccountId, direction = 'ALL') {
    const effects = new Map();
    for (const entry of row.entries) {
        if (readableIds.includes(entry.accountId))
            effects.set(entry.accountId, (effects.get(entry.accountId) || 0n) + BigInt(entry.amountMinor));
    }
    const matches = (value) => direction === 'ALL' || (direction === 'INCOME' ? value > 0n : value < 0n);
    const ids = [...effects.keys()].filter(id => (!selectedAccountId || id === selectedAccountId) && matches(effects.get(id))).sort();
    const accountId = ids.includes(row.accountId) ? row.accountId : ids[0];
    return { accountId: accountId || selectedAccountId || row.accountId,
        minor: accountId ? effects.get(accountId).toString() : row.kind === 'RECONCILE' && direction === 'ALL' ? '0' : null };
}
